import { DisputeStatusEnum, TERMINAL_DISPUTE_STATUSES } from 'utils/enums';
import type { Dispute } from 'api/escrow/types';

export function getActiveDispute(disputes: Dispute[]): Dispute | undefined {
  const active = disputes.find((d) => !TERMINAL_DISPUTE_STATUSES.includes(d.status as DisputeStatusEnum));
  if (active) return active;
  return [...disputes].sort((a, b) => {
    const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return (Number.isFinite(tb) ? tb : 0) - (Number.isFinite(ta) ? ta : 0);
  })[0];
}

export function hasOnlyTerminalDisputes(disputes: Dispute[]): boolean {
  return (
    disputes.length > 0 && disputes.every((d) => TERMINAL_DISPUTE_STATUSES.includes(d.status as DisputeStatusEnum))
  );
}
